import { required, TextInput } from "react-admin";
import { VehicleFormToolbar } from "../../misc/VehicleFormToolbar";
import { EntitledInstructorsInput } from "../../inputs/EntitledInstructorsInput";
import { Form2 } from "../../misc/Form2";
import { Column } from "../../misc/Column";
import type { SxProps } from "@mui/material";
import { useAutovioContext } from "../../hooks/useAutovioContext";

export function TrailerForm({ mode, sx }: { mode: "create" | "edit"; sx?: SxProps }) {
  const [{ drivingSchoolId }] = useAutovioContext();

  if (!drivingSchoolId) {
    return null;
  }

  return (
    <Form2
      warnWhenUnsavedChanges
      defaultValues={{
        type: "trailer",
        drivingSchoolId,
        name: "",
        notes: "",
        plateNumber: "",
        entitledInstructorIds: [],
      }}
    >
      <Column sx={sx}>
        <TextInput label="Name" source="name" autoFocus={mode === "create"} validate={required()} />
        <TextInput label="Notizen" source="notes" />
        <TextInput label="Kennzeichen" source="plateNumber" validate={required()} sx={{ width: "150px" }} />
        <EntitledInstructorsInput source="entitledInstructorIds" />
        <VehicleFormToolbar />
      </Column>
    </Form2>
  );
}
